import BabyFoodIcon from '../assets/babyFood.svg?no-inline'
import BeveragesIcon from '../assets/beverages.svg?no-inline'
import BonbonsIcon from '../assets/bonbons.svg?no-inline'
import CleaningIcon from '../assets/cleaning.svg?no-inline'
import CoffeeIcon from '../assets/coffee.svg?no-inline'
import DeoIcon from '../assets/deo.svg?no-inline'
import DiapersIcon from '../assets/diapers.svg?no-inline'
import EggsIcon from '../assets/eggs.svg?no-inline'
import FoodIcon from '../assets/food.svg?no-inline'
import HairIcon from '../assets/hair.svg?no-inline'
import HealthIcon from '../assets/health.svg?no-inline'
import HouseKeepingIcon from '../assets/housekeeping.svg?no-inline'
import ParfumIcon from '../assets/parfum.svg?no-inline'
import PastaIcon from '../assets/pasta.svg?no-inline'
import PetIcon from '../assets/pet.svg?no-inline'
import ShowerIcon from '../assets/shower.svg?no-inline'
import SweetsIcon from '../assets/sweets.svg?no-inline'
import ToiletPaperIcon from '../assets/toiletPaper.svg?no-inline'
import ToothBrushIcon from '../assets/tootBrush.svg?no-inline'

export type ShelfCategory = 'BABY_FOOD'
  | 'CLEANING'
  | 'DEO'
  | 'DIAPERS'
  | 'FOOD'
  | 'HAIR'
  | 'HEALTH'
  | 'PARFUM'
  | 'PET'
  | 'SHOWER_GEL'
  | 'TOILET_PAPER'
  | 'TOOTH_BRUSH'
  | 'BEVERAGES'
  | 'COFFEE'
  | 'EGGS'
  | 'PASTA'
  | 'SWEETS'
  | 'HOUSEKEEPING'
  | 'BONBONS'

export const iconMap: Record<ShelfCategory, string> = {
  BABY_FOOD: BabyFoodIcon,
  CLEANING: CleaningIcon,
  DEO: DeoIcon,
  DIAPERS: DiapersIcon,
  FOOD: FoodIcon,
  HAIR: HairIcon,
  HEALTH: HealthIcon,
  PARFUM: ParfumIcon,
  PET: PetIcon,
  SHOWER_GEL: ShowerIcon,
  TOILET_PAPER: ToiletPaperIcon,
  TOOTH_BRUSH: ToothBrushIcon,

  BEVERAGES: BeveragesIcon,
  COFFEE: CoffeeIcon,
  EGGS: EggsIcon,
  PASTA: PastaIcon,
  SWEETS: SweetsIcon,
  BONBONS: BonbonsIcon,
  HOUSEKEEPING: HouseKeepingIcon,
}